module.exports = __webpack_public_path__ + "/static/assets/04f3bdea3b46fc8ea2dc161d3b953956.png";